export default "__VITE_ASSET__085b95e5__"